import { ApiResponse, TokenData } from '../models';
import * as http from './http';
import ApiService from './service';

interface DocumentRejectedReasons {
    _id?: string;
    code: string;
    reason: string;
    visibility?: boolean;
    entityType: string;
}

export class DocumentRejectedReasonsService extends ApiService {

    public async loadAllDocumentRejectedReasons(data: any) {
        const url = `${this.apiDomain}/api/reasons/list`;

        const resposne = await http.post<ApiResponse<DocumentRejectedReasons[]>>(
            url,
            data,
            this.store
        );
        return resposne?.data?.data;
    }
    public async updateChangeDocumentRejectedReasons(data: any, id?: string) {
        const url = `${this.apiDomain}/api/reasons/${id}`;

        const response = await http.put<ApiResponse<TokenData>>(
            url,
            data,
            this.store
        );
        return response.data;
    }

    public async createDocumentRejectedReasons(data: any, id?: string) {
        const url = `${this.apiDomain}/api/reasons`;

        const response = await http.post<ApiResponse<TokenData>>(
            url,
            data,
            this.store
        );
        return response.data;
    }

    public async deleteDocumentRejectedReasons(id?: string) {
        const url = `${this.apiDomain}/api/reasons/${id}`;

        const response = await http.remove<ApiResponse<any>>(
            url,
            this.store
        );
        return response.data;
    }

}
